





















import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModule,
  InstallationModuleData,
  InstallationPlan,
  MechanicInstallation,
} from '@/types';

import Vue, { PropType, VueConstructor } from 'vue';
import { InstallationModuleStatus } from '@/store/modules/installation';

export default Vue.extend({
  props: {
    installation: { type: Object as PropType<MechanicInstallation> },
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    module: { type: Object as PropType<InstallationModule> },
  },

  computed: {
    plan(): InstallationPlan {
      return this.module.installationPlan!;
    },

    gridSize(): number {
      return (
        this.installation.screening?.numberOfPanels ??
        this.moduleData.grid?.reduce((i, val) => i + (val ? 1 : 0), 0) ??
        0
      );
    },
  },
});
